import { Usecase } from './Usecase'

export class CopyValueUsecase extends Usecase {
    invoke (value: unknown): void {
        this.setState({ lastCopyId: this.browserService.copy(value) })
    }
}
